(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-competition-draw-phrase.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-competition-draw-phrase.js');

'use strict';

const {
  useSelector
} = ReactRedux;
const {
  selectCurrentDrawCount
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;
const {
  useActiveCompetitionId,
  useCompetition
} = svs.components.marketplaceCompetition.services.hooks;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const useCompetitionDrawPhrase = () => {
  const activeCompetitionId = useActiveCompetitionId();
  const comp = useCompetition(activeCompetitionId);
  const compName = resolveCompetitionName(comp);
  const currentDrawCount = useSelector(state => selectCurrentDrawCount(state, activeCompetitionId));
  switch (currentDrawCount) {
    case 1:
      return "Rivstart i ".concat(compName, "?");
    case 2:
      return 'Redo för nästa omgång?';
    case 3:
      return "Halvlek i ".concat(compName);
    case 4:
      return 'Två omgångar kvar';
    case 5:
      return "Slutspurt i ".concat(compName);
    default:
      return 'Anmälan till årets tävling är stängd';
  }
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useCompetitionDrawPhrase', useCompetitionDrawPhrase);

 })(window);